import { render, staticRenderFns } from "./DailyTransactionLimits.vue?vue&type=template&id=6a52e99d"
import script from "./DailyTransactionLimits.vue?vue&type=script&lang=js"
export * from "./DailyTransactionLimits.vue?vue&type=script&lang=js"
import style0 from "./DailyTransactionLimits.vue?vue&type=style&index=0&id=6a52e99d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports